 export function checkUserInput(inputLines) {
    let inputPrompt = ''
    const userInputs = []
    let beforePrompt
    let inputText
    let i = 0
    const regex = /input\(["']([^"']*)["']\);?/;
    const inputTextRegex = new RegExp(regex);
    let inputTextOnly

    if (inputLines.includes("input(")) {

      inputPrompt = inputLines.match(/input\(["']([^"']*)["']\);?/g);

      while (inputPrompt?.length > 0 && (i < inputPrompt?.length)) {

        inputTextOnly = inputTextRegex.exec(inputPrompt[i])[1];
        inputText = prompt(inputTextOnly);

        if (inputText !== null) {
          userInputs.push(inputText);
          // eslint-disable-next-line prefer-template       
          beforePrompt = inputLines.replace(inputPrompt[i], "'" + userInputs[i] + "'");
          inputLines = beforePrompt;
        }
        i += 1

      }
    }
    return inputLines
  }
  export function getOutputTextSQL(codeValue, result,data) {
    console.log(codeValue, result,data,"111111111111");
    

    const dateString = "date";
    const timeString = "time";
    const nowString = "now";
    const formatdateString = "format";
    const dataFrameString = "DataFrame";

    const isDateFunction = codeValue.toLowerCase() === dateString;


    const isTimeFunction = codeValue.toLowerCase() === timeString;
    const isNowFunction = codeValue.toLowerCase() === nowString;
    const isFormatFunction = codeValue.toLowerCase() === formatdateString;
    const isDataFrameFunction = codeValue.toLowerCase() === dataFrameString;

    const isCreateTableQuery = codeValue.toLowerCase().includes("create table");
    const isUpdateTableQuery = codeValue.toLowerCase() === "update";
    const isDeleteTableQuery = codeValue.toLowerCase().includes("delete");
    const isDropTableQuery = codeValue.toLowerCase().includes("drop table");
    const isAlterTableQuery = codeValue.toLowerCase().includes("alter table");
    const isSelectQuery = codeValue.toLowerCase().includes("select");

    let output;

    //  dev environment
    const isDevEnvironment = process.env.REACT_APP_ENV === 'dev';


    if (isDevEnvironment) {



      if (isCreateTableQuery && typeof result === 'string' && result === "[]") {
        const tableName = (codeValue.match(/create table (\w+)/i) || [])[1] || "the table";
        output = `Table "${tableName}" has been created successfully.`;
      }
      else if (isUpdateTableQuery && typeof result === 'string' && result === "[]") {
        const tableName = (codeValue.match(/update (\w+)/i) || [])[1] || "the table";
        output = `Table "${tableName}" has been updated successfully.`;
      }
      else if (isDeleteTableQuery && typeof result === 'string' && result === "[]") {
        const tableName = (codeValue.match(/delete from (\w+)/i) || [])[1] || "the table";
        output = `Records from table "${tableName}" have been deleted successfully.`;
      }
      else if (isDropTableQuery && typeof result === 'string' && result === "[]") {
        const tableName = (codeValue.match(/drop table (\w+)/i) || [])[1] || "the table";
        output = `Table "${tableName}" has been dropped successfully.`;
      }
      else if (isAlterTableQuery && typeof result === 'string' && result === "[]") {
        const tableName = (codeValue.match(/alter table (\w+)/i) || [])[1] || "the table";
        output = `Table "${tableName}" has been altered successfully.`;
      }
      else if (isSelectQuery && typeof result === 'string' && result.toLowerCase().includes("no such column")) {
        output = result.replace(/"/g, '');

      }
      else if (codeValue.toLowerCase().includes("insert into") && typeof result === 'string' && result === "[]") {
        const tableName = (codeValue.match(/insert into (\w+)/i) || [])[1] || "the table";
        output = `Records has been successfully inserted into table ${tableName} table.`;
      }
      else if (!output && typeof result === 'string' && result.toLowerCase().includes("already exists")) {
        output = result.replace(/"/g, '').replace(/table/i, 'Table');
      }
      else if (!output && typeof result === 'string' && result.toLowerCase().includes("syntax error")) {
        const cleanResult = result.replace(/"/g, '').replace(/\\/g, '');
        const errorPart = (cleanResult.match(/near\s+(\w+)/) || [])[1] || "unknown syntax error";
        output = `Syntax error: near ${errorPart}`;
      }
      else if (!output && typeof result === 'string' && result.toLowerCase().includes("no column named")) {
        output = result?.replace(/"/g, '');
      }
      else if (isSelectQuery) {
        output = formatAsTable(result);
      }
      else if (data?.subcategory?.code === 'SEQUEL' && result && (() => {
        try {
          const parsed = JSON.parse(result);
          return Array.isArray(parsed);
        } catch (e) {
          return false;
        }
      })()
      ) {
        const parsedArray = JSON.parse(result);
        const htmlTable = convertToHTMLTable(parsedArray);
        output = htmlTable
      }

      else {
        output = result?.replace(/"/g, '');
      }
    }

    if (!output) {
      if (isDataFrameFunction) {
        output = formatAsTable(result);
      } else if (isDateFunction && data?.subcategory?.code === 'SEQUEL') {
        output = new Date().toLocaleDateString();
      } else if (isTimeFunction && data?.subcategory?.code === 'SEQUEL') {
        output = new Date().toLocaleTimeString().substring(0, 8);
      } else if (isNowFunction && data?.subcategory?.code === 'SEQUEL') {
        output = new Date().toISOString();
        // } else if (isFormatFunction && location?.state?.subcategory?.code === 'SEQUEL') {
        //   output = moment(new Date()).format('DD-MM-YYYY');
      }



      else if (data?.subcategory?.code === 'SEQUEL' && result && (() => {
        try {
          const parsed = JSON.parse(result);
          return Array.isArray(parsed);
        } catch (e) {
          return false;
        }
      })()
      ) {
        const parsedArray = JSON.parse(result);
        const htmlTable = convertToHTMLTable(parsedArray);
        output = htmlTable
      }

      else {
        output = result;
      }
    }
    if (typeof output === "string" && typeof codeValue === "string") {
      const normalizedCode = codeValue.trim().toLowerCase();
      const normalizedOutput = output.trim().toLowerCase();

      const isInsert = normalizedCode.startsWith("insert into");
      // const isupdate = normalizedCodeLower.startsWith("update");
      const isupdate = normalizedCode.toLowerCase().includes("update") || normalizedCode.toLowerCase().includes("set");

      // isupdate && (isNoData || isDateOnly


      const isCreate = normalizedCode.startsWith("create table");
      const isAlterAdd = normalizedCode.startsWith("alter table") && normalizedCode.includes("add column");
      const isNoData = normalizedOutput === "<p>no data</p>";
      const isNoDataupdate = "[]";

      let isDateOnly = false;
      const parsedDate = Date.parse(output);
      if (!Number.isNaN(parsedDate)) {
        isDateOnly = true;
      }

      if (isInsert && (isNoData || isDateOnly)) {
        output = "Data inserted successfully";

      } else if (isCreate && (isNoData || isDateOnly)) {
        output = "Table created successfully";

      }
      else if (isupdate && (isNoData || isDateOnly || isNoDataupdate && result === '[]')) {

        output = "Data updated successfully";

      }

      else if (isAlterAdd && (isNoData || isDateOnly)) {
        const tableMatch = codeValue.match(/alter table\s+([^\s]+)/i);
        const columnMatch = codeValue.match(/add column\s+([^\s]+)/i);

        const tableName = tableMatch ? tableMatch[1] : "table";
        const columnName = columnMatch ? columnMatch[1] : "column";

        output = `Column '${columnName}' added to '${tableName}' table successfully.`;
      }
    }

    return output;
  }

   function convertToHTMLTable(data) {
    if (!Array.isArray(data) || data.length === 0) return "<p>No data</p>";

    const headers = Object.keys(data[0]);

    const tableStyle = `
      style="border-collapse: collapse; width: 100%;"
    `;
    const thTdStyle = `
      style="border: 1px solid #333; padding: 8px; text-align: left;"
    `;

    const headerRow = headers.map(h => `<th ${thTdStyle}>${h}</th>`).join("");
    const rows = data.map(obj =>
      `<tr>${headers.map(h => `<td ${thTdStyle}>${obj[h] ?? ""}</td>`).join("")}</tr>`
    ).join("");

    return `<table ${tableStyle}>
              <thead><tr>${headerRow}</tr></thead>
              <tbody>${rows}</tbody>
            </table>`;
  }


   export function getOutputText(codeValue, result,data) {
    console.log(codeValue, result,data,"codeValue, result,locatiocodeValue, result,locatio");
    
      const dateString = "date";
      const timeString = "time";
      const nowString = "now";
      const formatdateString = "format";
      const dataFrameString = "DataFrame";
  
      const isDateFunction = codeValue.includes(dateString);
      const isTimeFunction = codeValue.includes(timeString);
      const isNowFunction = codeValue.includes(nowString);
      const isFormatFunction = codeValue.includes(formatdateString);
      const isDataFrameFunction = codeValue.includes(dataFrameString);
  
      const isCreateTableQuery = codeValue.toLowerCase().includes("create table");
      const isUpdateTableQuery = codeValue.toLowerCase().includes("update");
      const isDeleteTableQuery = codeValue.toLowerCase().includes("delete");
      const isDropTableQuery = codeValue.toLowerCase().includes("drop table");
      const isAlterTableQuery = codeValue.toLowerCase().includes("alter table");
      const isSelectQuery = codeValue.toLowerCase().includes("select");
  
      let output;
  
  
  
      //  dev environment
      const isDevEnvironment = process.env.REACT_APP_ENV === 'dev';
  
  
      if (isDevEnvironment) {
  
        if (isCreateTableQuery && typeof result === 'string' && result === "[]") {
          const tableName = (codeValue.match(/create table (\w+)/i) || [])[1] || "the table";
          output = `Table "${tableName}" has been created successfully.`;
        }
        else if (isUpdateTableQuery && typeof result === 'string' && result === "[]") {
          const tableName = (codeValue.match(/update (\w+)/i) || [])[1] || "the table";
          output = `Table "${tableName}" has been updated successfully.`;
        }
        else if (isDeleteTableQuery && typeof result === 'string' && result === "[]") {
          const tableName = (codeValue.match(/delete from (\w+)/i) || [])[1] || "the table";
          output = `Records from table "${tableName}" have been deleted successfully.`;
        }
        else if (isDropTableQuery && typeof result === 'string' && result === "[]") {
          const tableName = (codeValue.match(/drop table (\w+)/i) || [])[1] || "the table";
          output = `Table "${tableName}" has been dropped successfully.`;
        }
        else if (isAlterTableQuery && typeof result === 'string' && result === "[]") {
          const tableName = (codeValue.match(/alter table (\w+)/i) || [])[1] || "the table";
          output = `Table "${tableName}" has been altered successfully.`;
        }
        else if (isSelectQuery && typeof result === 'string' && result.toLowerCase().includes("no such column")) {
          output = result.replace(/"/g, '');
        }
        else if (codeValue.toLowerCase().includes("insert into") && typeof result === 'string' && result === "[]") {
          const tableName = (codeValue.match(/insert into (\w+)/i) || [])[1] || "the table";
          output = `Records has been successfully inserted into table ${tableName} table.`;
        }
        else if (!output && typeof result === 'string' && result.toLowerCase().includes("already exists")) {
          output = result.replace(/"/g, '').replace(/table/i, 'Table');
        }
        else if (!output && typeof result === 'string' && result.toLowerCase().includes("syntax error")) {
          const cleanResult = result.replace(/"/g, '').replace(/\\/g, '');
          const errorPart = (cleanResult.match(/near\s+(\w+)/) || [])[1] || "unknown syntax error";
          output = `Syntax error: near ${errorPart}`;
        }
        else if (!output && typeof result === 'string' && result.toLowerCase().includes("no column named")) {
          output = result.replace(/"/g, '');
        }
        else if (isSelectQuery) {
          output = formatAsTable(result);
        }
        else {
          output = result.replace(/"/g, '');
        }
      }
  
      if (!output) {
        if (isDataFrameFunction) {
          output = formatAsTable(result);
        } else if (isDateFunction && data?.subcategory?.code === 'SEQUEL') {
          output = new Date().toLocaleDateString();
        } else if (isTimeFunction && data?.subcategory?.code === 'SEQUEL') {
          output = new Date().toLocaleTimeString().substring(0, 8);
        } else if (isNowFunction && data?.subcategory?.code === 'SEQUEL') {
          output = new Date().toISOString();
          // } else if (isFormatFunction && location?.state?.subcategory?.code === 'SEQUEL') {
          //   output = moment(new Date()).format('DD-MM-YYYY');
        }
        else {
          output = result;
        }
      }
      return output;
    }
  
   
  
  
    function formatAsTable(result) {
  
      let data;
      try {
        data = JSON.parse(result);
      } catch (error) {
        return 'Invalid data format';
      }
  
      if (!Array.isArray(data) || data.length === 0) {
        return 'No data available';
      }
  
      const headers = Object.keys(data[0]);
  
      let table = '<table style="border-collapse: collapse; width: 100%;">';
  
      table += '<tr style="background-color: #f2f2f2;">';
      headers.forEach(header => {
        table += `<th style="border: 1px solid #ddd; padding: 8px; text-align: left;">${header}</th>`;
      });
      table += '</tr>';
  
      data.forEach(employee => {
        table += '<tr>';
        headers.forEach(header => {
          table += `<td style="border: 1px solid #ddd; padding: 8px;">${employee[header]}</td>`;
        });
        table += '</tr>';
      });
  
      table += '</table>';
      return table;
    }